var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagBanner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.7063 15.2812C21.7943 15.3913 21.8497 15.5239 21.8658 15.6639C21.882 15.8039 21.8584 15.9457 21.7977 16.0729C21.7371 16.2001 21.6418 16.3076 21.5228 16.3832C21.4038 16.4587 21.2659 16.4992 21.125 16.5H4.625V20.25C4.625 20.4489 4.54598 20.6397 4.40533 20.7803C4.26468 20.921 4.07391 21 3.875 21C3.67609 21 3.48532 20.921 3.34467 20.7803C3.20402 20.6397 3.125 20.4489 3.125 20.25V4.5C3.125 4.30109 3.20402 4.11032 3.34467 3.96967C3.48532 3.82902 3.67609 3.75 3.875 3.75H21.125C21.2659 3.75079 21.4038 3.79128 21.5228 3.86683C21.6418 3.94237 21.7371 4.04992 21.7977 4.17713C21.8584 4.30435 21.882 4.44609 21.8658 4.5861C21.8497 4.72611 21.7943 4.85873 21.7063 4.96875L17.5813 10.125L21.7063 15.2812Z",
    fill: "white",
    fillOpacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagBanner);
export default __webpack_public_path__ + "static/media/FlagBanner.44002912c71c14ac10093e662f54951a.svg";
export { ForwardRef as ReactComponent };